<template>
  <v-layout>
    <v-flex xs12>
      <app-loader
        v-if="!isShipping"
        title="Загрузка данных Отгрузки"
        :loading="!pageLoaded"
      />
      <v-card v-show="pageLoaded || isShipping">
        <v-card-title class="pb-0">
          <v-layout align-center>
            <v-tooltip
              v-if="!isShipping"
              bottom
            >
              <v-btn
                slot="activator"
                small
                icon
                class="ma-0"
                @click="$router.go(-1)"
              >
                <v-icon color="grey darken-1">
                  arrow_back
                </v-icon>
              </v-btn>
              <span>Назад</span>
            </v-tooltip>
            <h1 class="px-2 subheading font-weight-bold">
              Отгрузка клиенту
            </h1>
            <v-chip
              v-if="+id"
              small
              class="font-weight-bold"
            >
              {{ `ID: ${releaseOrder.id}` }}
            </v-chip>
            <v-chip
              v-if="+id && releaseOrder.releaseOrderFact"
              small
              outline
              class="font-weight-bold grey--text text--darken-3"
            >
              {{
                `Фактическая дата отгрузки: ${$options.filters.date(
                  releaseOrder.releaseOrderFact
                )}`
              }}
            </v-chip>
            <v-spacer />
            <v-btn
              v-if="releaseOrder.id !== 0"
              small
              :color="releaseOrder.isRemoved ? 'success' : 'error'"
              :data-test="
                releaseOrder.isRemoved ? 'restoreButton' : 'deleteButton'
              "
              :loading="loadingRemovedState"
              :disabled="disabled"
              @click="releaseConfirmDialog = true"
            >
              {{ releaseOrder.isRemoved ? "Восстановить" : "Удалить" }}
            </v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text class="pa-0">
          <MainFormEditor
            :id="id"
            :disabled="disabled"
            :is-shipping="isShipping"
            @validChanged="(value) => (valid = value)"
          />
          <v-layout
            v-if="isNew && isShipping"
            class="px-3 pb-3"
            align-center
          >
            <v-layout row>
              <v-btn
                small
                color="primary"
                class="mr-2 text-xs-right"
                :disabled="!valid || disabled"
                :loading="orderLoading"
                @click="save"
              >
                Сохранить
              </v-btn>
              <v-btn
                small
                class="mx-0 text-xs-right"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-layout>
          </v-layout>
          <v-layout
            v-else
            class="px-3 pb-3"
            column
          >
            <v-flex>
              <v-layout>
                <v-btn
                  small
                  flat
                  :color="isShippingItemsActive ? 'primary' : ''"
                  @click="isShippingItemsActive = true"
                >
                  ПОСТАВКИ НА ОТГРУЗКУ
                </v-btn>
                <v-btn
                  small
                  flat
                  :color="isShippingItemsActive ? '' : 'primary'"
                  @click="isShippingItemsActive = false"
                >
                  ФОТО
                </v-btn>
                <v-divider
                  v-if="isShippingItemsActive"
                  vertical
                  class="mx-2"
                />

                <MenuItemEditor
                  v-if="isShippingItemsActive"
                  :id="id"
                  :valid="valid"
                  :disabled="disabled || isReleaseOrderDisabledToEdit"
                  :disable-add-not-is-partial="disableAddNotIsPartial"
                  @close="closeItemEditor"
                  @saveAfter="save"
                />
                <v-tooltip
                  v-if="isSyncDisabled"
                  top
                >
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-btn
                        slot="activator"
                        :disabled="
                          !needSync ||
                            disabled ||
                            isSyncDisabled ||
                            releaseOrder.hasNotArrivedShippings ||
                            isReleaseOrderDisabledToEdit
                        "
                        class="my-2 mx-2"
                        color="primary"
                        small
                        @click="syncWithERP"
                      >
                        Синхронизировать с ERP
                      </v-btn>
                    </span>
                  </template>
                  <span>
                    Для синхронизации с ERP необходимо:<br>
                    - заполнить поле Выберите службу.<br>
                    - добавить Адрес места прибытия.<br>
                    - выбрать Адрес места прибытия в поставке(ах).<br>
                  </span>
                </v-tooltip>
                <v-btn
                  v-else
                  slot="activator"
                  :disabled="
                    !needSync ||
                      disabled ||
                      isSyncDisabled ||
                      releaseOrder.hasNotArrivedShippings ||
                      isReleaseOrderDisabledToEdit
                  "
                  class="my-2 mx-2"
                  color="primary"
                  small
                  @click="syncWithERP"
                >
                  Синхронизировать с ERP
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex>
              <ShippingsTable
                v-if="isShippingItemsActive"
                :id="id"
                :disabled="disabled || isReleaseOrderDisabledToEdit"
                class="mt-2"
              />
              <ImagesList
                v-else
                :id="id"
                block-height="auto"
                :is-top="true"
                width="350px"
                resource="release-orders"
                :disabled="disabled || isReleaseOrderDisabledToEdit"
              />
            </v-flex>
            <v-flex>
              <v-layout
                v-if="isShipping"
                align-center
                mt-3
              >
                <v-btn
                  small
                  class="ma-0"
                  @click="cancel"
                >
                  Закрыть
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <app-action-confirm
        :value="showActionDialog"
        text="Вы действительно хотите покинуть отгрузку? Данные не синхронизированы с ERP"
        @cancel="closeActionDialog"
        @confirm="confirmActionDialog"
      />
    </v-flex>
    <app-action-confirm
      :value="releaseConfirmDialog"
      :text="releaseConfirmDialogText"
      @cancel="releaseConfirmDialog = false"
      @confirm="releaseConfirmAction"
    />
  </v-layout>
</template>

<script>
import MenuItemEditor from "./components/ReleaseOrderMenuItemEditor.vue";
import ShippingsTable from "./components/ShippingsTable.vue";
import * as ordersApi from "../../backend/releaseOrdersApi.js";
import * as basErpApi from "../../backend/basErpApi.js";
import MainFormEditor from "./components/ReleaseOrderMainFormEditor.vue";
import { eTransportTypes } from "./components/transport-types.js";
import ImagesList from "../../components/images/ImagesList.vue";

export default {
  components: { MenuItemEditor, ShippingsTable, MainFormEditor, ImagesList },
  props: ["id", "isShipping", "disabled"],
  data() {
    return {
      valid: false,
      orderLoading: false,
      itemEditorDialog: false,
      title: "Поставки на отгрузку",
      isShippingItemsActive: true,
      releaseConfirmDialog: false,
      loadingRemovedState: false,
      showActionDialog: false,
      route: null,
      readyToLeave: false,
    };
  },
  computed: {
    releaseOrder() {
      return this.$store.getters["releaseOrders/releaseOrder"];
    },
    needSync() {
      return this.$store.getters["releaseOrders/needSync"];
    },
    transportTypes() {
      return this.$store.getters["releaseOrders/transportTypes"];
    },
    shippingId() {
      if (!this.isShipping) {
        return null;
      }
      return this.$store.getters["shipping/shipping"].Id;
    },
    isNew() {
      return +this.id ? false : true;
    },
    releaseOrderPeriod: {
      get() {
        return this.$store.getters["releaseOrders/releaseOrderPeriod"];
      },
      set(period) {
        this.$store.commit("releaseOrders/setReleaseOrderPeriod", period);
      },
    },
    eTransportTypes() {
      return eTransportTypes;
    },
    pageLoaded() {
      return (
        !this.orderLoading &&
        !this.$store.getters["releaseOrders/shippingsLoading"]
      );
    },
    releaseConfirmDialogText() {
      if (!this.releaseOrder.isRemoved) {
        return "Вы действительно хотите удалить отгрузку?";
      } else {
        return "Вы действительно хотите восстановить отгрузку?";
      }
    },
    isTypeCourierActive() {
      return (
        this.releaseOrder.transportType === this.eTransportTypes.COURIERSERVICE
      );
    },
    shippings() {
      return this.$store.getters["releaseOrders/shippings"];
    },
    isSyncDisabled() {
      if (!this.isTypeCourierActive) {
        return false;
      }
      const isShippingsWithArrivalPlace =
        this.shippings.filter((s) => s.arrivalPlaceId).length ===
        this.shippings.length;
      return !(
        this.isTypeCourierActive &&
        this.releaseOrder.courier?.company &&
        isShippingsWithArrivalPlace
      );
    },
    disableAddNotIsPartial() {
      return this.$store.getters["releaseOrders/disableAddNotIsPartial"];
    },
    isReleaseOrderDisabledToEdit() {
      const shippings = this.shippings;
      const releasedShippings = shippings.some((item) => {
        return item.released === true;
      });
      const notReleasedShippings = shippings.some((item) => {
        return item.released === false;
      });

      return releasedShippings && !notReleasedShippings;
    },
  },
  async created() {
    this.orderLoading = true;
    await this.$store.dispatch("releaseOrders/getData", this.id);
    this.$store.commit("releaseOrders/setNeedSync", this.releaseOrder.needSync);
    this.orderLoading = false;
  },
  beforeRouteLeave(to, from, next) {
    if ((!this.needSync && !this.isChanged) || this.readyToLeave) {
      next();
    } else {
      this.route = to;
      this.showActionDialog = true;
      next(false);
    }
  },
  methods: {
    async save(shippingItem) {
      const item = {
        releaseOrderPlan: this.releaseOrder.releaseOrderPlan,
        releaseOrderPeriodId: this.releaseOrderPeriod.value,
        senderAddressId: this.releaseOrder.senderAddress.id,
        transport:
          this.releaseOrder.transportType != eTransportTypes.COURIERSERVICE &&
          this.releaseOrder.transport
            ? this.releaseOrder.transport
            : {
              registrationNumber: "",
              driver: null,
              phone: "",
            },
        deliveryInfo:
          this.releaseOrder.transportType === eTransportTypes.COURIERSERVICE &&
          this.releaseOrder.courier
            ? {
              courierServiceId: this.releaseOrder.courier.company
                ? this.releaseOrder.courier.company.id
                : null,
              waybillNumber: this.releaseOrder.courier.waybillNumber,
            }
            : {
              courierServiceId: null,
              waybillNumber: "",
            },
        transportTypeId: this.releaseOrder.transportType,
        arrivalPlaces: this.releaseOrder.arrivalPlaces.length
          ? this.releaseOrder.arrivalPlaces.map((item) => {
            return {
              id: item.id,
              address: item.address,
            };
          })
          : null,
      };
      if (this.isNew) {
        this.orderLoading = true;
        const newId = await ordersApi.createReleaseOrders(item);
        if (this.isShipping) {
          const shippingInfo = {
            shippingId: this.shippingId,
            volume: this.releaseOrder.volume,
            cargoPlaces: this.releaseOrder.cargoPlaces,
            isPartial: this.releaseOrder.isPartial,
            number: this.releaseOrder.number,
            notes: this.releaseOrder.notes,
          };
          await ordersApi.createReleaseOrdersShipping(newId, shippingInfo);
          await this.$store.dispatch(
            "shipping/getReleaseOrders",
            this.shippingId
          );
          this.$emit("close");
        } else if (shippingItem) {
          await ordersApi.createReleaseOrdersShipping(newId, shippingItem);
          this.$router.replace(`/release-orders/${newId}`);
        } else {
          this.$router.replace(`/release-orders/${newId}`);
        }
        this.orderLoading = false;
        this.showInfo("Отгрузка добавлена");
      } else {
        this.orderLoading = true;
        await ordersApi.updateReleaseOrders(this.id, item);
        this.orderLoading = false;
        this.showInfo("Изменения сохранены");
      }
    },
    async syncWithERP() {
      this.orderLoading = true;
      await basErpApi.syncWithERP(this.id);
      this.$store.commit("releaseOrders/setNeedSync", false);
      this.orderLoading = false;
    },
    closeItemEditor() {
      this.itemEditorDialog = false;
    },
    cancel() {
      this.$emit("close", false);
      this.isChanged = false;
    },
    async releaseConfirmAction() {
      this.releaseConfirmDialog = false;
      this.loadingRemovedState = true;
      await ordersApi.changeRemovedState(
        this.releaseOrder.id,
        this.releaseOrder.isRemoved
      );
      const result = await basErpApi.getNeedSync(this.id);
      this.$store.commit("releaseOrders/setNeedSync", result);
      this.loadingRemovedState = false;
      this.releaseOrder.isRemoved = !this.releaseOrder.isRemoved;
    },
    resetLoaders() {
      this.loadingRemovedState = false;
    },
    confirmActionDialog() {
      this.readyToLeave = true;
      this.showActionDialog = false;
      this.$router.push(this.route);
    },
    closeActionDialog() {
      this.showActionDialog = false;
      this.readyToLeave = false;
      this.route = null;
    },
  },
};
</script>
<style>
.v-chip.release-chip .v-chip__content {
  margin: 0 auto !important;
}
</style>
